import React from "react";
import clsx from "clsx";
import { motion } from "framer-motion";
import MenuItem from "../MenuItem";
import { animationContainer1, animationItem1 } from "../utils/animationLevel1";

import styles from "./Level1.styles";

const Level1 = ({ handleLevel1Click, items, menuLevel2Ref, selectedMenuLevel1ID }) => {
	const css = styles();

	return (
		<motion.nav
			animate="animate"
			aria-label="Menu"
			aria-modal
			className={clsx(css.level1, "mco-view-component-desktopmenu__level1")}
			id="menu"
			initial="initial"
			role="dialog"
			variants={animationContainer1}
		>
			{items?.map(item => (
				<motion.div
					className={clsx({
						[css.hideOnDesktop]:
							item?.tag === "mobile-voucher" || item?.tag === "mobile-enquiry"
					})}
					data-id={item.id}
					key={item.id}
					variants={animationItem1}
				>
					<MenuItem
						connectorRef={menuLevel2Ref}
						hasChildren={item.items?.length > 0}
						item={item}
						level={1}
						onClick={handleLevel1Click}
						selected={item.id === selectedMenuLevel1ID}
					/>
				</motion.div>
			))}
		</motion.nav>
	);
};

export default Level1;
